var DataTransformer        = require("./DataTransformer"),
    MediaDetailView        = require("./MediaDetailView"),
    MediaNotFoundView      = require("./MediaNotFoundView"),
    MediaRepository        = require("app/Domain/Ott/Api/V2/DataAccess/Media/Repository"),
    PopupContentController = require("app/core/PopupContentController"),
    OopsView               = require("./OopsView"),
    deepEqual              = require("fast-deep-equal"),
    get                    = require("object-path").get,
    kind                   = require("enyo/kind"),
    logger                 = require("enyo/logger");

module.exports = kind(/** @lends  app.MediaDetailPopup.PopupController.prototype */ {

    /**
     * @private
     */
    name: "app.MediaDetailPopup.PopupController",

    /**
     * @private
     */
    kind: PopupContentController,

    /**
     * @private
     */
    handlers: {
        onRequestClose: "onRequestClose"
    },

    /**
     * @param  {Object}    activation           The activation object
     * @param  {Object}    activation.params    Parameters to tell us what to do
     * @param  {boolean}   activation.finished  Flag if activation is finished
     * @param  {function}  activation.resolve   A promise resolver to fire when
     *                                          the page is active.
     * @param  {function}  activation.reject    A promise rejector to fire when
     *                                          the page failed to activate.
     * @public
     */
    execute: function(activation) {
        var $popup          = this.popup,
            defaultLanguage = this.app.$.i18nService.getDefaultLanguage(),
            language        = get(activation, "params.language", null) || defaultLanguage,
            mediaType       = get(activation, "params.mediaType", null) || "",
            mediaSlug       = get(activation, "params.mediaSlug", null) || "",
            skipCache       = get(activation, "params.skipCache", false);

        // Loading graphic
        $popup.requestShowLoadingGraphic();

        // Load Media
        MediaRepository.getByTypeAndSlug(skipCache, language, mediaType, mediaSlug)

            // Show View
            .then(this.bindSafely(function(mediaResponse) {
                var mediaData;

                // The activation was canceled, we can bail early.
                if (activation.finished) {
                    return;
                }

                if (mediaResponse.status === "ok") {
                    mediaData = DataTransformer.transformData(language, mediaResponse.data);
                    this.updateState(activation.params, mediaData);
                    this.updateView(MediaDetailView);
                    this.updateDocumentTitle();
                }
                else {
                    this.updateState(activation.params);

                    switch (mediaResponse.type) {
                        case "not_found_error":
                            this.updateView(MediaNotFoundView);
                            break;
                        case "server_error":
                        case "server_timeout_error":
                        case "bad_request_error":
                        default:
                            this.updateView(OopsView);
                            break;
                    }

                    this.updateDocumentTitle();
                }
                activation.resolve(1);
            }))

            // Oops
            .catch(this.bindSafely(function(error) {
                logger.error(error);

                if (typeof Sentry !== "undefined" && error instanceof Error) {
                    Sentry.captureException(error);
                }

                // The activation was canceled, we can bail early.
                if (activation.finished) {
                    return;
                }

                this.updateState(activation.params);
                this.updateView(OopsView);
                this.updateDocumentTitle();
                activation.resolve(1);
            }))

            // No more loading graphic
            .finally(function() {
                $popup.requestHideLoadingGraphic();
            });
    },

    /**
     * @param  {Object}   params     The params passed to this controller
     * @param  {Object=}  mediaData  Freshly loaded media data
     * @private
     */
    updateState: function(params, mediaData) {
        var state = {};

        // Build state
        state.params = params;
        state.data   = mediaData || null;

        // Update state only if it actually changed
        if (!deepEqual(this.state, state)) {
            this.set("state", state);
        }

        // Broadcast state changes to app state
        this.app.$.state.set("mediaDetailsMediaType", get(mediaData, "type", null));
        this.app.$.state.set("mediaDetailsMediaSlug", get(mediaData, "meta.slug", null));
        this.app.$.state.set("mediaDetailsMediaId", get(mediaData, "id", null));
    },

    /**
     * @private
     */
    updateDocumentTitle: function() {
        var i18nService = this.app.$.i18nService,
            state       = this.state || {},
            title       = get(state, "data.meta.title", null);

        if (this.app.get("documentTitleOwner") !== this) {
            return;
        }

        if (title) {
            this.app.setDocumentTitle(i18nService.getString("app.MediaDetailPopup.Document.Title.title", {
                title: String(title || "")
            }));
        }
        else {
            this.app.setDocumentTitle(i18nService.getString("app.MediaDetailPopup.Document.Title.noTitle"));
        }
    },

    /**
     * @method
     * @private
     */
    activeChanged: function() {
        var $appState = this.app.$.state;

        if ($appState.get("mediaDetailsController") === this) {
            $appState.set("mediaDetailsActive", this.get("active"));
        }
    },

    /**
     * @private
     */
    onRequestClose: function() {
        var $router       = this.app.$.router,
            state         = this.state || {},
            media         = get(state, "data", null),
            context       = get(state, "params.context", null),
            ancestorLink,
            ancestorLinks = [],
            shared;

        // Collect ancestor links
        while (get(media, "parent", null)) {
            ancestorLink = get(media, "parent.links.self", null);
            ancestorLink && ancestorLinks.push(ancestorLink);
            media        = media.parent;
        }

        shared = (new URL(window.location.href)).searchParams.has("shared");

        if (ancestorLinks.includes(context) && shared) {
            $router.navigate(context);
        }
        else {
            $router.back();
        }
    }

});
